import styled from 'styled-components';

import Button from '../Button';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.space.s5};
  margin-top: ${({ theme }) => theme.space.s9};
  margin-bottom: ${({ theme }) => theme.space.s9};
  text-align: center;
  padding-left: ${({ theme }) => theme.space.s5};
  padding-right: ${({ theme }) => theme.space.s5};
`;

export const Continue = styled(Button).attrs({
  type: 'button',
  size: 'medium',
})`
  margin-top: ${({ theme }) => theme.space.s5};
  width: 504px;
  max-width: 100%;
`;
